import RuiButton from 'app/components/rui/RuiButton.vue';
import RuiCheckbox from 'app/components/rui/RuiCheckbox.vue';

export default {
  install (Vue) {
    Vue.component('rui-button', RuiButton);
    Vue.component('rui-checkbox', RuiCheckbox);
  },
};



// WEBPACK FOOTER //
// ./common/plugins/rui.js